import __base_store from '@/store/__base_store'

/**
 * Store de IVA (modelo `iva`) construido desde el factory común.
 */
export default __base_store({
	/** Estado propio del modelo `iva`. */
	state: {
		model_name: 'iva',
	},
})

